"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timers_1 = require("timers");
exports.handleOpenOverviewModalDisplay = () => (dispatch) => {
    dispatch({
        type: 'TRIGGERED_ANIMATION',
        trigger: '',
    });
    dispatch({
        type: 'OPEN_OVERVIEW_MODAL',
    });
};
exports.handleCloseOverviewModalDisplay = (history, path) => (dispatch) => {
    dispatch({
        type: 'TRIGGERED_ANIMATION',
        trigger: '',
    });
    dispatch({
        type: 'CLOSING_OVERVIEW_MODAL',
    });
    timers_1.setTimeout(() => {
        history.push(path);
    }, 325);
};
exports.handleSendTestModalDisplay = (on) => (dispatch) => {
    if (on) {
        dispatch({
            type: 'SET_SEND_TEST_MODAL_OPEN',
        });
    }
    else {
        dispatch({
            type: 'SET_SEND_TEST_MODAL_CLOSE',
        });
    }
};
